import { IAppState } from '../../../AppModulesWrapper';

export function selectTotalArea(state: IAppState): number | null | undefined {
  return state.servicePickerWidget.offer.totalArea;
}
